import { Container, Title } from "@mantine/core";
import { useTranslation } from "react-i18next";
import { TasksTable } from "./components";

export const View = () => {
  const { t } = useTranslation();

  return (
    <Container fluid>
      <Title mt="xl" mb="xl" weight={500} order={3}>
        {t("TASKS")}
      </Title>

      <TasksTable />
    </Container>
  );
};
